var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00365 11.4331L5.07031 10.4831L8.90365 6.66641H0.570312V5.33307H8.90365L5.07031 1.49974L6.00365 0.566406L11.437 5.99974L6.00365 11.4331Z",
    fill: "url(#paint0_linear_224_485)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_485",
    x1: 11.2493,
    y1: 5.97188,
    x2: 0.570313,
    y2: 5.97188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AD9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGradient);
export default __webpack_public_path__ + "static/media/arrowRightGradient.ee3ea2af71a432e921846a21370e7536.svg";
export { ForwardRef as ReactComponent };